import { useSearchParams } from "react-router-dom";
import LandingPageForm from "../components/LandingPageForm";

const CreateLandingPage = () => {
  const [searchParams] = useSearchParams();
  const duplicateFrom = searchParams.get("duplicateFrom");

  return (
    <div>
      <h2 className="mt-4 mb-4 text-xl tracking-wider uppercase">
        {duplicateFrom ? "Дублирай лендинг-страница" : "Създай нова лендинг-страница"}
      </h2>
      <LandingPageForm key={duplicateFrom || "new"} duplicateFrom={duplicateFrom} />
    </div>
  );
};

export default CreateLandingPage;
